<template>
	<div class="content">
	
		<span>智慧城市车辆静态交通运管服务平台</span>

	</div>
</template>
<script>
	export default {
		name:"",
		data:function(){
			return{
				
			}
		},
		methods:{
			
		}
    }
</script>
<style scoped>
.content{
	/* background:#f9f9fb; */
	/* height:60px; */
	z-index:60000;
	/* border-top:10px solid #eff2f7; */
	display:flex;
	justify-content: center;
	align-items: center;
	height:40px;

}
span{
	display:block;
}
</style>